exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link {\r\n    font-size: 1.2em;\r\n}\r\n\r\n.link a {\r\n    color: #0091CD;\r\n}\r\n\r\n.link a:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.loading {\r\n    text-align: center;\r\n    font-size: 1.3em;\r\n    padding-top: 38px;\r\n}\r\n\r\n.lineList .rows {\r\n    padding: 2px 0;\r\n}\r\n\r\n.gray-font {\r\n    color: #a09c9c;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/anouncement-list/anouncement-list.component.css
// module id = ../../../../../src/app/home/components/anouncement-list/anouncement-list.component.css
// module chunks = main